module.exports = __webpack_public_path__ + "img/img9.cd41ed6d.png";